import React, { PropsWithChildren } from 'react';

import { Box } from '@betterment/samba-react';

const borderGradient =
  'conic-gradient(from 0deg, #f56b0f, #f56b0f 45deg, token(colors.border) 120deg, #f56b0f 215deg, #f56b0f 245deg, #ffc729 305deg, #f56b0f)';

export const GradientBorderBox: React.FC<PropsWithChildren> = ({ children }) => (
  <Box css={{ padding: '1px', borderRadius: '8px', background: borderGradient }}>
    <Box css={{ position: 'relative', borderRadius: '7.76px', background: 'background.surface' }}>{children}</Box>
  </Box>
);
